import React from 'react'
import PropTypes from 'prop-types'
import { Card, Grid } from '@mui/material'
import ReactECharts from 'echarts-for-react'
import { countBy, isNil } from 'lodash'
import { VIGILANCE } from 'dashboard/utils/DashboardUtils'
import GlobalNoteCard from 'gdl/globalNote/GlobalNoteCard'

const STATUS_DEF = [
    { value: 1, name: 'Démarrage', color: '#00b0f0' },
    { value: 2, name: 'En cours', color: '#92d050' },
    { value: 3, name: 'Archivé', color: '#bfbfbf' },
]

const VIGILANCE_DEF = [
    { match: v => isNil(v), name: 'Aucune', color: '#92d050' },
    { match: v => v === VIGILANCE.MEDIUM, name: 'Moyenne', color: 'orange' },
    { match: v => v === VIGILANCE.HIGH, name: 'Élevée', color: 'red' },
]

// Chef de projet interne (Aquasys) : contributeur CHIEF avec un login, pas un intervenant externe.
const chiefName = (customer) => customer.contributors?.find(c => c.typeContributor === 'CHIEF' && c.login)?.name || 'Non défini'

// En dessous de ce pourcentage, la part est trop fine pour y loger le nombre : il reste dans le libellé extérieur.
const MIN_PERCENT_INSIDE = 5

const PieCard = ({ title, data }) => {
    const pieSeries = { type: 'pie', radius: ['40%', '65%'], top: 20, data }
    // Une série ne porte qu'un seul label : la 2e, superposée et silencieuse, affiche le nombre dans la part.
    const options = {
        title: { text: title, left: 'center', top: 6, textStyle: { fontSize: 13, fontWeight: 'bold' } },
        tooltip: { trigger: 'item', formatter: '{b} : {c} ({d}%)' },
        series: [{
            ...pieSeries,
            label: {
                show: true,
                position: 'outside',
                formatter: (p) => {
                    if (!p.value) {
                        return ''
                    }
                    return p.percent < MIN_PERCENT_INSIDE ? `${p.name} (${p.value})` : p.name
                },
                fontSize: 11,
            },
            labelLine: { show: true, length: 6, length2: 8 },
        }, {
            ...pieSeries,
            silent: true,
            label: {
                show: true,
                position: 'inside',
                formatter: (p) => (p.value && p.percent >= MIN_PERCENT_INSIDE ? `${p.value}` : ''),
                fontSize: 12,
                fontWeight: 'bold',
                color: '#fff',
            },
            labelLine: { show: false },
        }],
    }
    return (
        <Card>
            <ReactECharts option={options} notMerge={true} lazyUpdate={true} style={{ height: '280px' }} />
        </Card>
    )
}

PieCard.propTypes = {
    title: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
}

// 3 camemberts de répartition des clients (respectent le filtre courant) : statut, vigilance, chef de projet.
const CustomersCharts = ({ customers = [] }) => {
    const statusData = STATUS_DEF.map(s => ({ value: customers.filter(c => c.status === s.value).length, name: s.name, itemStyle: { color: s.color } }))
    const vigilanceData = VIGILANCE_DEF.map(v => ({ value: customers.filter(c => v.match(c.vigilance)).length, name: v.name, itemStyle: { color: v.color } }))
    const chiefData = Object.entries(countBy(customers, chiefName)).map(([name, value]) => ({ name, value }))

    return (
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
            <Grid size={3}><PieCard title='Répartition par statut' data={statusData} /></Grid>
            <Grid size={3}><PieCard title='Répartition par vigilance' data={vigilanceData} /></Grid>
            <Grid size={3}><PieCard title='Répartition par chef de projet' data={chiefData} /></Grid>
            <Grid size={3}><GlobalNoteCard /></Grid>
        </Grid>
    )
}

CustomersCharts.propTypes = {
    customers: PropTypes.arrayOf(PropTypes.shape({})),
}

export default CustomersCharts
